import { render } from "./ProfitLossPage.vue?vue&type=template&id=323e7040&scoped=true&ts=true"
import script from "./ProfitLossPage.vue?vue&type=script&lang=ts"
export * from "./ProfitLossPage.vue?vue&type=script&lang=ts"

import "./ProfitLossPage.vue?vue&type=style&index=0&id=323e7040&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323e7040"]])

export default __exports__